import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth, API } from "./AuthContext";
import { Loader2 } from "lucide-react";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;

    if (!session_id) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        await axios.post(
          `${API}/auth/session`,
          { session_id },
          { withCredentials: true }
        );
        window.history.replaceState(null, "", "/dashboard");
        await refresh();
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setErr("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/", { replace: true }), 1600);
      }
    })();
  }, [location, navigate, refresh]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[color:var(--mati-sand)]"
      data-testid="auth-callback"
    >
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-6 h-6 animate-spin text-[color:var(--mati-clay)]" />
        <div className="font-mono-ui text-[11px] tracking-[0.3em] uppercase text-[color:var(--mati-muted)]">
          {err ? err : "Signing you in — one moment"}
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
